import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useLinksSection} from '../useGetProductBulkSection';
import {
  GoBackWithCategoryLabelProps,
  GoBackWithCategoryLabelView,
} from './GoBackWithCategoryLabelView';

export const GoBackWithCategoryLabel: React.FC<
  GoBackWithCategoryLabelProps
> = props => {
  return (
    <DataFetcher
      request={useLinksSection()}
      Error={null}
      View={GoBackWithCategoryLabelView}
      /** already render the view as most of the times the data from the backend will not be used and the default (history back) is good enough. This allows to render the components in one batch which improves performance on transition from listing page to adp. */
      Loading={GoBackWithCategoryLabelView}
      viewProps={props}
    />
  );
};
